export default __webpack_public_path__ + "static/media/alliedHangers4.f2ae40e3.jpg";